import * as React from "react";
const SvgIcArrowSelect = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Vector 1", d: "M2 6L10 14L18 6", stroke: "black", strokeLinecap: "round" }));
export default SvgIcArrowSelect;
